define('home/views/ProfileFollowingCommunitiesEmptyView',[
    'backbone-marionette',
    'home/templates/profileFollowingCommunitiesEmpty',
], function (
    Marionette,
    profileFollowingCommunitiesEmptyTemplate
) {
    'use strict';

    /**
     * Shows a message that the backing user model doesn't follow any communities.
     * Expects a user model.
     */
    var ProfileFollowingCommunitiesEmptyView = Marionette.ItemView.extend({
        template: profileFollowingCommunitiesEmptyTemplate,
        templateHelpers: function () {
            return {
                isSessionUser: this.model.isSessionUser(),
            };
        },
    });

    return ProfileFollowingCommunitiesEmptyView;
});

